import { Location } from "history";

export default function useGetUrlSearchParams(
  location: Location
): URLSearchParams {
  return new URLSearchParams(location.search);
}
